import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PageWrapper = ({ children, noPadding = false, fullWidth = false }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className={`flex-1 ${noPadding ? '' : 'py-6 sm:py-8'}`}>
        <div className={fullWidth ? '' : 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'}>
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PageWrapper;